var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoteToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "url(#paint0_linear_44_63844)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5875 11.9984H13.4125L12.4375 10.8984L13.15 10.1859L14.5 11.7234V14.9984H5.5V11.7234L6.875 10.1609L7.5875 10.8734L6.5875 11.9984ZM10.025 11.8984L6.85 8.72344L10.7375 4.83594L13.9125 8.01094L10.025 11.8984ZM10.025 10.4859L12.5 8.01094L10.7375 6.24844L8.2625 8.72344L10.025 10.4859ZM6.5 13.9984H13.5V12.9984H6.5V13.9984ZM6.5 13.9984V12.9984V13.9984Z",
    fill: "url(#paint1_linear_44_63844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_63844",
    x1: 0,
    y1: 0,
    x2: 24.1954,
    y2: 3.87071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968467,
    stopColor: "#6633CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FF44B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_63844",
    x1: 5.5,
    y1: 4.83594,
    x2: 16.4469,
    y2: 6.38686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968467,
    stopColor: "#6633CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FF44B8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteToken);
export default __webpack_public_path__ + "static/media/VoteToken.d314bd81a2c2c5e3f7fe16e261a4c6d6.svg";
export { ForwardRef as ReactComponent };